<template lang="html" >
  <b-form @submit="inviaRichiesta"  v-if="is_ready" class="form-richiesta-prodotto">
    <!-- <pre>{{form.product_type}}</pre> -->
    <h2>Richiedi prodotto</h2>
    <div class="row">
      <div class="col-md-12" style="padding-top:10px;padding-bottom:20px;">
        Tutti i campi contrassegnati con '*' sono obbligatori
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-form-group label="Email*">
          <b-input v-model="form.email" required />
        </b-form-group>

        <b-form-group label="Indirizzo (Specificare la provincia)*">
          <b-input v-model="form.address" required />
        </b-form-group>


        <b-form-group label="Numero di telefono*">
          <b-input  v-model="form.number" required />
        </b-form-group>

        <b-form-group label="Tipologia">
          <b-form-radio v-model="form.prType" value="std">Standard</b-form-radio>
          <b-form-radio v-model="form.prType" value="notStd">Fuori Standard</b-form-radio>
          <b-form-radio v-model="form.prType" value="varie">Varie</b-form-radio>
        </b-form-group>
      </div>
      <div v-if="form.prType == 'std'" class="col-md-12">
        <b-form-group label="Scegli uno standard">
          <b-form-select v-model="form.stdSelection" :options="options"></b-form-select>
        </b-form-group>
      </div>


      <div class="row riga-fix" v-else-if="form.prType  == 'notStd'">
        <div class="col-md-6">
          <b-form-group label="Lato A corto (mm)*">
            <b-input v-model="form.side_a" required />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Lato B lungo (mm)*">
            <b-input v-model="form.side_b" required />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Portata (Kg)*">
            <b-select v-model="form.weight_range" >
              <option value="500">
                LEGGERO - da 1 a 500 kg circa (spessore tav. fino a 15 mm. con TAPPO 6/8 cm)
              </option>
              <option value="1000">
                FORTE - da 501 a 1000 Kg circa (spessore tav. da 16  a 20 mm. con TAPPO 9/10 cm.)
              </option>
              <option value="99999">
                ROBUSTO - da 1001 a 1500Kg circa (spessore tav. da 21 a 25 mm. con TAPPO 11/13 cm.)
              </option>
            </b-select>
          </b-form-group>
        </div>
        <div class="col-md-6">
          Numero vie <br>
          <b-select v-model="form.shape"  >
            <option>2 vie</option>
            <option>4 vie</option>
            <option>americano</option>
          </b-select>
        </div>
        <div class="col-md-12 lista-caratteristiche">
          <b-checkbox v-model="form.is_transpallet" >
            Transpallet
          </b-checkbox>
          <b-checkbox v-model="form.is_bounded" >
            Perimetrato
          </b-checkbox>
          <b-checkbox v-model="form.is_filled" >
            Piano Pieno
          </b-checkbox>
          <b-checkbox v-model="form.reversable" >
            Reversibile
          </b-checkbox>
          <b-checkbox v-model="form.opposite" >
            Contrario
          </b-checkbox>
        </div>
      </div>
      <div class="row riga-fix" style="width:100%;" v-else-if="form.prType  != null">
        <div class="col-md-12">
          <b-form-group  label="Descrizione prodotto">
            <b-textarea  v-model="form.description" required />
          </b-form-group>
        </div>
      </div>





      <div class="col-md-12">
        <b-form-group label="Quantità*">
          <b-input v-model="form.quantity" required />
        </b-form-group>
      </div>
      <div class="col-md-12 mb-3">

        <b-form-group label="Descrizione/note">
          <b-textarea v-model="form.admin_notes"  />
        </b-form-group>
      </div>



    </div>


    <div class="text-right">
      <b-button type="submit" variant="primary">Invia Richiesta</b-button>
    </div>
    <!-- <b-modal v-model="modalShow" hide-footer hide-header>
      Email inviata con successo
      <button @click="modalShow = !modalShow ">OK</button>
    </b-modal> -->
  </b-form>


</template>

<script>


export default {
  components: {
  },
  // props: ['form'],
  data() {
    return {
      product_types: [],
      modalShow : false,
      is_ready: true,
      form : {},
      options: [
        { value: 'EPAL', text: 'EPAL' },
        { value: 'CP1', text: 'CP1' },
        { value: 'CP2', text: 'CP2' },
        { value: 'CP3', text: 'CP3' },
        { value: 'CP4', text: 'CP4' },
        { value: 'CP5', text: 'CP5' },
        { value: 'CP6', text: 'CP6' },
        { value: 'CP7', text: 'CP7' },
        { value: 'CP8', text: 'CP8' },
        { value: 'CP9', text: 'CP9' },
        { value: 'VMF', text: 'VMF' },
        { value: 'EUR', text: 'EUR' },
        { value: 'DUSSELDORF', text: 'DUSSELDORF' },
      ]
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    // save() {
    //   this.$http.post('products', this.form).then(res => {
    //     this.$emit('close')
    //     this.$emit('saved', res.data)
    //   })
    // },



    inviaRichiesta(evt) {

      evt.preventDefault()



      this.$http.post('requestProduct', this.form).then(res => {
        console.log('inviato' + res)
        alert('Richiesta inoltrata con successo')
        console.log('successo')
        this.form = {}
      })


    }
  },

  watch: {
    'form.prType'() {
      this.form.stdSelection = null
      this.form.side_a = ""
      this.form.side_b = ""
      this.form.weight_range = null
      this.form.shape = null

      this.form.is_transpallet = false
      this.form.is_bounded = false
      this.form.is_filled = false
      this.form.reversable = false
      this.form.opposite = false

    },
  }
}
</script>

<style lang="css" scoped>
  .disponibilita-annuncio{
    padding-top:30px;
    padding-bottom:20px;
  }
  .form-richiesta-prodotto{
    max-width: 600px;
    margin: auto;
    padding-top:40px;
  }
  .lista-caratteristiche .custom-control{
    padding-right:20px;
    width: 20%;
    float: left;
  }
  .riga-fix{
    margin-left:0px;
    margin-right:0px;
  }
  @media only screen and (max-width: 767px){
    .riga-fix{
      margin-left:0px;
      margin-right:0px;
    }
    .lista-caratteristiche .custom-control {
      width: 100%;
      float: none;
    }
    .lista-caratteristiche{
      padding-top:15px;
      padding-bottom:15px;
    }
  }
</style>
